import React, { PropsWithChildren, RefObject } from 'react';

type TopItemType = { ref?: RefObject<HTMLDivElement | null> } & PropsWithChildren;

export function TopItem({ children, ref }: TopItemType) {
  return (
    <div className="main-navigation__top-item" ref={ref}>
      <div className="main-navigation__top-linkbox">{children}</div>
    </div>
  );
}
